<template>
  <div class="container-fluid">
    <div v-if="isInitiated && isClosed">
      <div class="row">
        <div class="col-12 col-sm-7 col-md-6 col-lg-4 mx-auto">
          <h5>Прием показаний за прошедший месяц закрыт.</h5>
        </div>
      </div>
    </div>
    <div v-if="isInitiated && !isClosed">
      <div class="row">
        <div class="col-12 col-sm-7 col-md-6 col-lg-4 mx-auto">
          <div class="form-group">
            <label for="accountId">Введите идентификатор лицевого счета</label>
            <input type="text" v-model="accountId" @input="handleInputAccountId()" minlength="10" maxlength="10" class="form-control" id="accountId" aria-describedby="accountIdHelp" placeholder="введите идентификатор лицевого счета">
            <small id="accountIdHelp" class="form-text text-muted">десять символов, только цифры</small>
          </div>
        </div>
      </div>
    </div>
    <div v-if="account" class="p-3 mb-2 bg-info text-white">
      <h3>адрес</h3>
      {{ account.address }}
    </div>
    <div v-if="account" class="p-3 mb-2">
      <label>
        Выберите услугу
        <select v-model="selectedService" v-on:change="handleSelectService" class="form-control">
          <option v-for="option in serviceOptions" v-bind:value="option.value">
            {{ option.text }}
          </option>
        </select>
      </label>
    </div>
    <div v-if="account && serviceCounters.length > 0" class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th class="align-top">
              Введите последние<br>
              четыре цифры номера счетчика
            </th>
            <th class="align-top">
              Информация о счетчике
            </th>
            <th class="align-top">
              Последние рассчитанные показания
            </th>
            <th class="align-top">
              Новое показание
              <small class="form-text text-muted">все цифры, без точки</small>
            </th>
            <th class="align-top">
              <span v-if="selectedService === 'electricity'">
                Расход, Вт
              </span>
              <span v-if="selectedService !== 'electricity'">
                Расход, м&sup3;
              </span>
              <small class="form-text text-muted">расчитывается по последнему и новому показанию</small>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(counter, index) in serviceCounters">
            <td class="align-middle">
              <input type="text" v-model="counter.lastNumbers" @input="handleInputCounterLastNumbers(index)" minlength="4" maxlength="4" class="form-control"/>
            </td>
            <td class="align-middle">
              <span v-if="!counter.data">
                cчетчик не найден
              </span>
              <span v-if="counter.data">
                Счетчик "{{ counter.data.СounterNumber }}"<br>
                расположение - не указано<br>
                дата окончания поверки {{ counterCheckDateHtml(counter.data.CounterCheckDate) }}
              </span>
            </td>
            <td class="align-middle">
              <div v-if="!counter.data">
                -
              </div>
              <div v-if="counter.data && counter.data.value_count === 1">
                <span v-html="lastInputValueHtml(counter.data)"></span> на {{ (new Date(counter.data.CounterInputDate)).toLocaleDateString() }}
              </div>
              <div v-if="counter.data && counter.data.value_count === 2">
                <div>
                  Дневные показания: <span v-html="lastInputValueHtml(counter.data)"></span>
                </div>
                <div>
                  Ночные показания: <span v-html="lastInputValueHtml(counter.data, 'night')"></span>
                </div>
                <div>
                  на {{ (new Date(counter.data.CounterInputDate)).toLocaleDateString() }}
                </div>
              </div>
            </td>
            <td class="align-middle">
              <div v-if="!counter.data">
                <input :disabled="true" class="form-control"/>
              </div>
              <div v-if="counter.data && counter.data.value_count === 1 && (counter.data.ServiceType === 'hot_water' || counter.data.ServiceType === 'cold_water')">
                <TheMask mask="#########" v-model="counter.newValue" :masked="true" @input="handleInputCounterNewValue(index)" class="form-control"></TheMask>
              </div>
              <div v-if="counter.data && counter.data.value_count === 1 && (counter.data.ServiceType === 'electricity')">
                <TheMask mask="######" v-model="counter.newValue" :masked="true" @input="handleInputCounterNewValue(index)" class="form-control"></TheMask>
              </div>
              <div v-if="counter.data && counter.data.value_count === 2 && (counter.data.ServiceType === 'hot_water' || counter.data.ServiceType === 'cold_water')">
                <div>
                  <label>
                    <TheMask mask="#########" v-model="counter.newValue" :masked="true" @input="handleInputCounterNewValue(index)" class="form-control"></TheMask>
                  </label>
                </div>
                <div>
                  <label>
                    <TheMask mask="#########" v-model="counter.newNightValue" :masked="true" @input="handleInputCounterNewValue(index)" class="form-control"></TheMask>
                  </label>
                </div>
              </div>
              <div v-if="counter.data && counter.data.value_count === 2 && (counter.data.ServiceType === 'electricity')">
                <div>
                  <label>
                    <TheMask mask="######" v-model="counter.newValue" :masked="true" @input="handleInputCounterNewValue(index)" class="form-control"></TheMask>
                  </label>
                </div>
                <div>
                  <label>
                    <TheMask mask="######" v-model="counter.newNightValue" :masked="true" @input="handleInputCounterNewValue(index)" class="form-control"></TheMask>
                  </label>
                </div>
              </div>
            </td>
            <td class="align-middle">
              <div v-if="!counter.data">
                -
              </div>
              <div v-if="counter.data && counter.data.value_count === 1">
                <span v-if="counter.newValue">
                  {{ counter.consumption }}
                </span>
                <span v-if="!counter.newValue">
                  -
                </span>
              </div>
              <div v-if="counter.data && counter.data.value_count === 2">
                <div>
                  {{ counter.consumption }}
                </div>
                <div>
                  {{ counter.nightConsumption }}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <button :disabled="!isSaveAllowed" v-on:click="handleSaveCounters" class="btn btn-info">Сохранить показания</button>
    </div>
    <div v-if="account && serviceCounters.length === 0">
      <span>Счетчики по указанному идентификатору лицевого счета не найдены</span>
    </div>
    <loading v-bind:show="isLoading || !isInitiated"/>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from './Loading';
import { TheMask } from 'vue-the-mask'

// const baseUrl = 'http://api.counters.ifedko.pro';
// const baseUrl = 'http://rsinfo.ru/api-counters';
// const baseUrl = 'http://89.108.65.32';
const baseUrl = 'http://counters.uk-trudovoe.ru/api';

const lengthOfWaterValue = 9;
const lengthOfElectricityValue = 6;

export default {
    name: 'MetersReadings',
    components: {
        'loading': Loading,
        'TheMask': TheMask
    },
    data: function() {
        return {
            isInitiated: false,
            isClosed: false,
            isLoading: false,
            accountId: '',
            account: null,
            serviceOptions: [],
            selectedService: '',
            serviceCounters: [],
            isSaveAllowed: false
        };
    },
    mounted() {
        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                this.getServiceStatus();
            }
        }
    },
    methods: {
        handleInputAccountId: function() {
            this.account = null;
            this.serviceOptions = [];
            this.selectedService = '';
            this.serviceCounters = [];
            this.isSaveAllowed = false;
            if (this.accountId.length === 10) {
                this.getAccount(this.accountId);
            }
        },
        handleSelectService: function(value) {
            this.serviceCounters = this.initServiceCounters(this.account.counters, this.selectedService);
            this.isSaveAllowed = false;
        },
        handleInputCounterLastNumbers: function(index) {
            if (this.account && this.selectedService && this.serviceCounters[index].lastNumbers.length === 4) {
                this.isLoading = true;

                setTimeout(function() {
                    const foundOriginalCounterLastNumbers = this.serviceCounters
                        .filter(item => !!item.data)
                        .map(item => this.getCounterLastNumbers(item.data.СounterNumber));
                    const serviceCounters = this.account.counters.filter((item) => {
                        const originalCounterLastNumbers = this.getCounterLastNumbers(item.СounterNumber);
                        return (
                            item.ServiceType === this.selectedService &&
                            originalCounterLastNumbers === this.serviceCounters[index].lastNumbers &&
                            !foundOriginalCounterLastNumbers.includes(this.serviceCounters[index].lastNumbers)
                        );
                    });

                    if (serviceCounters.length > 0) {
                        const counterData = serviceCounters[0];
                        this.serviceCounters[index].data = counterData;
                        this.serviceCounters[index].newValue = counterData.LastInputValueWeb > 0 ?
                            counterData.LastInputValueWeb :
                            '';
                        this.serviceCounters[index].consumption = this.calculateConsumption(
                            counterData.LastInputValue, this.serviceCounters[index].newValue, counterData.ServiceType
                        );
                        if (counterData.value_count === 2) {
                            this.serviceCounters[index].newNightValue = counterData.LastInputValueNightWeb > 0 ?
                                counterData.LastInputValueNightWeb :
                                '';
                            this.serviceCounters[index].nightConsumption = this.calculateConsumption(
                                counterData.LastInputValueNight, this.serviceCounters[index].newNightValue, counterData.ServiceType
                            );
                        }
                    }
                    this.isLoading = false;
                }.bind(this), 250);
            } else {
                this.serviceCounters[index].data = null;
                this.isSaveAllowed = false;
            }
        },
        handleInputCounterNewValue: function(index) {
            if (
                this.account && this.selectedService &&
                this.serviceCounters[index].lastNumbers.length === 4
            ) {
                this.serviceCounters[index].consumption = this.calculateConsumption(
                    this.serviceCounters[index].data.LastInputValue,
                    this.serviceCounters[index].data.ServiceType === 'electricity'
                        ? this.serviceCounters[index].newValue
                        : this.waterValueToReal(this.serviceCounters[index].newValue),
                    this.serviceCounters[index].data.ServiceType
                );
                if (this.serviceCounters[index].data.value_count === 2) {
                    this.serviceCounters[index].nightConsumption = this.calculateConsumption(
                        this.serviceCounters[index].data.LastInputValueNight,
                        this.serviceCounters[index].data.ServiceType === 'electricity'
                            ? this.serviceCounters[index].newNightValue
                            : this.waterValueToReal(this.serviceCounters[index].newNightValue),
                        this.serviceCounters[index].data.ServiceType
                    );
                }

                this.isSaveAllowed = this.saveIsAllowed();
            } else {
                this.isSaveAllowed = false;
            }
        },
        handleSaveCounters: function() {
            if (this.account && this.selectedService && this.isSaveAllowed) {
                this.putCounter(this.serviceCounters);
                this.isSaveAllowed = false;
            }
        },
        getServiceStatus: function() {
            const api = axios.create({
                  baseURL: baseUrl
              });
            this.isLoading = true;
            api
                .get(`/isready/*`)
                .then(response => {
                    const data = response.data;

                this.isClosed = !data.IsReady;
                this.isLoading = false;
                this.isInitiated = true;
            })
            .catch(error => {
                console.log('Error', error.message);
                this.isClosed = true;
                this.isLoading = false;
                this.$snotify.error('Возникла ошибка. Попробуйте позже.');
            });
        },
        getAccount: function(accountId) {
            const api = axios.create({
                  baseURL: baseUrl
              });
            this.isLoading = true;
            api
                .get(`/GetCounters?id_client=${accountId}`)
                .then(response => {
                    const
                        data = response.data,
                        address = data[0].Dom || '',
                        apartment = data[0].Flat || '';

                    this.account = {
                        id: accountId,
                        address: address + ', ' + apartment,
                        counters: data
                    };
                    this.serviceOptions = this.initServicesOptionsFromCounters(data);
                    if (this.serviceOptions.length > 0) {
                        this.selectedService = this.serviceOptions[0].value;
                        this.serviceCounters = this.initServiceCounters(data, this.selectedService);
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        this.$snotify.error('Данные по идентификатору лицевого счета не найдены. Обратитесь в абонентский отдел.');
                    } else {
                        console.log('Error', error.message);
                        this.$snotify.error('Данные по идентификатору лицевого счета не удалось загрузить. Попробуйте позже.');
                    }
                    this.isLoading = false;
                });
        },
        putCounter: function(counters) {
            const
                api = axios.create({
                    baseURL: baseUrl
                }),
                countersData = counters.map(counter => ({
                    Ref_Counter: counter.data.Ref_Counter,
                    InputValue: counter.data.ServiceType === 'electricity'
                        ? Number(counter.newValue)
                        : this.waterValueToReal(counter.newValue),
                    InputValueNight: counter.newNightValue ? Number(counter.newNightValue) : 0
                }));
            this.isLoading = true;
            api
                .post('/PostCounters', countersData)
                .then(response => {
                    this.account.counters = this.account.counters.map((originalCounter) => {
                        const counterData = countersData.find((data) => {
                            return (data.Ref_Counter === originalCounter.Ref_Counter);
                        });
                        console.log('counterData', counterData);
                        if (counterData) {
                            originalCounter.LastInputValueWeb = counterData.InputValue;
                            originalCounter.LastInputValueNightWeb = counterData.InputValueNight;
                        }
                        return originalCounter;
                    });
                    this.isLoading = false;
                    this.$snotify.success('Показания успешно сохранены');
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$snotify.error('Показания не сохранены. Попробуйте сохранить позднее.');
                });
        },
        initServicesOptionsFromCounters: function(counters) {
            return counters.reduce((list, counter) => {
                const existingService = list.find(service => service.value === counter.ServiceType);
                if (!existingService) {
                    list.push({
                        text: counter.ServiceTypeDesc,
                        value: counter.ServiceType
                    });
                }
                return list;
            }, []);
        },
        findServiceCounters: function(allCounters, selectedServiceType) {
            return allCounters.filter(
                counter => (counter.ServiceType === selectedServiceType)
            );
        },
        initServiceCounters: function(allCounters, selectedServiceType) {
            return this
                .findServiceCounters(allCounters, selectedServiceType)
                .map(counter => (this.emptyServiceCounter()));
        },
        emptyServiceCounter: function() {
            return {
              data: null,
              lastNumbers: '',
              newValue: '',
              newNightValue: '',
              consumption: 0,
              nightConsumption: 0
            };
        },
        getCounterLastNumbers: function(counterNumber) {
            return counterNumber.substr(counterNumber.length - 4);
        },
        waterValueToReal: function (value) {
            return (Number(value) / 1000).toFixed(3);
        },
        calculateConsumption: function(currentValue, newValue, type) {
            if ((Number(newValue) < Number(currentValue))) {
                return 0;
            }

            return (type === 'electricity')
                ? (Number(newValue) - Number(currentValue))
                : (Number(newValue) - Number(currentValue)).toFixed(3);
        },
        isCounterValid: function(counter) {
            if (!counter.data) {
                return false;
            }
            if (
                (counter.data.ServiceType === 'hot_water' || counter.data.ServiceType === 'cold_water') &&
                (this.waterValueToReal(counter.newValue) < Number(counter.data.LastInputValue))
            ) {
                return false;
            }
            if (
                counter.data.ServiceType === 'electricity' &&
                counter.newValue < Number(counter.data.LastInputValue)
            ) {
                return false;
            }
            if (
                (counter.data.value_count === 2 && (Number(counter.newNightValue) < Number(counter.data.LastInputValueNight)))
            ) {
                return false;
            }

            return true;
        },
        saveIsAllowed: function() {
            if (this.account && this.selectedService) {
                let countersCanBeSaved = true;
                this.serviceCounters.forEach(counter => {
                    countersCanBeSaved = countersCanBeSaved && this.isCounterValid(counter);
                });
                return countersCanBeSaved;
            }
            return false;
        },
        // helpers
        lastInputValueHtml: function(data, type) {
            let valueString = "";
            if (data.ServiceType === 'electricity') {
                valueString = type === "night"
                    ? data.LastInputValueNight.toString()
                    : data.LastInputValue.toString();
            } else {
                valueString = type === "night"
                    ? data.LastInputValueNight.toFixed(3).toString()
                    : data.LastInputValue.toFixed(3).toString();
            }

            if (data.ServiceType === 'hot_water' || data.ServiceType === 'cold_water') {
                let firstPart = valueString;
                let secondPart = "000";
                if (valueString.indexOf(".") > -1) {
                    firstPart = valueString.substring(0, valueString.indexOf("."));
                    secondPart = valueString.substring(valueString.indexOf(".") + 1);
                }
                const zerosCount = lengthOfWaterValue - (firstPart + secondPart).length;
                const zerosPart = Array(zerosCount + 1).join("0");
                return zerosPart + firstPart + "<span style='color: deepskyblue'>" + secondPart + "</span>";
            } else if (data.ServiceType === 'electricity') {
                const zerosCount = lengthOfElectricityValue - valueString.length;
                const zerosPart = Array(zerosCount + 1).join("0");
                return zerosPart + valueString;
            }

            return data.LastInputValue;
        },
        counterCheckDateHtml: function(value) {
            const date = new Date(value);
            if (date.getFullYear() < 1900) {
                return "\"-\"";
            }
            return date.toLocaleDateString();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
